module.exports = __webpack_public_path__ + "img/button_qiehuan_3d_02.60c9dcc1.png";